import React, { useState, useEffect } from "react"
import Box from "@material-ui/core/Box"
import Button from "@material-ui/core/Button"
import Dialog from "@material-ui/core/Dialog"
import DialogActions from "@material-ui/core/DialogActions"
import DialogContent from "@material-ui/core/DialogContent"
import DialogTitle from "@material-ui/core/DialogTitle"
import Divider from "@material-ui/core/Divider"
import get from "lodash/get"
import CommaPrice from "src/features/Utils/CommaPrice"
import Preview from "./Preview"
import Typography from "@material-ui/core/Typography"
import { processOrder } from "../ducks"
import { useSelector, useDispatch } from "react-redux"

function ProcessModal({ children, medicine, supply, handleCheckout }) {
  const dispatch = useDispatch()
  const calculate = useSelector((state) => state.create_order.calculate)
  const [open, setOpen] = useState(false)

  const openModal = () => {
    setOpen(true)
  }

  const closeModal = () => {
    setOpen(false)
  }

  useEffect(() => {
    if (open) {
      dispatch(processOrder({ medicine, supply }))
    }
  }, [open])

  return (
    <>
      {React.cloneElement(children, { onClick: openModal })}
      <Dialog
        fullWidth
        aria-labelledby="ckeckout-dialog-title"
        aria-describedby="ckeckout-dialog-description"
        open={open}
        onClose={closeModal}
      >
        <DialogTitle id="ckeckout-dialog-title">Checkout</DialogTitle>
        <DialogContent dividers>
          <Typography variant="body2" gutterBottom>
            Order Summary
          </Typography>
          <Typography variant="subtitle2" color="textSecondary" gutterBottom>
            All prices and taxes
          </Typography>
          <Box display="flex">
            <Box p={1} flexGrow={1}>
              <Typography variant="body2">Subtotal</Typography>
            </Box>
            <Box p={1}>
              <Typography variant="body2">
                {CommaPrice(get(calculate, "sub_total", 0))}
              </Typography>
            </Box>
          </Box>
          <Divider />
          <Box display="flex">
            <Box p={1} flexGrow={1}>
              <Typography variant="body2">Discount</Typography>
            </Box>
            <Box p={1}>
              <Typography variant="body2">
                - {CommaPrice(get(calculate, "discount", 0))}
              </Typography>
            </Box>
          </Box>
          {get(calculate, "bundle", []).map((record) => {
            const _id = get(record, "_id")
            const image = get(record, "cover_img", "")
            const name = get(record, "name", "")
            const amount = get(record, "amount", "")
            const total = get(record, "total_discount", "")
            return (
              <Preview
                key={_id}
                image={image}
                name={name}
                amount={amount}
                total={total}
              />
            )
          })}

          <Divider />
          <Box display="flex">
            <Box p={1} flexGrow={1}>
              <Typography variant="body2">Shipping Fee:</Typography>
            </Box>
            <Box p={1}>
              <Typography variant="body2">Free</Typography>
            </Box>
          </Box>
          <Divider />
          <Box display="flex" alignItems="center">
            <Box p={1} flexGrow={1}>
              <Typography variant="body2">Grand total:</Typography>
            </Box>
            <Box p={1}>
              <Typography variant="h6" align="right">
                {CommaPrice(get(calculate, "total", 0))}
              </Typography>
              <Typography variant="caption" color="textSecondary">
                this price include 7% VAT.
              </Typography>
            </Box>
          </Box>
        </DialogContent>
        <DialogActions>
          <Button onClick={closeModal} color="primary">
            BACK
          </Button>
          <Button onClick={handleCheckout} variant="contained" color="primary">
            PLACE ORDER
          </Button>
        </DialogActions>
      </Dialog>
    </>
  )
}

export default ProcessModal
